<script setup lang="ts">
import GButton from '../GButton.vue';


withDefaults(defineProps<{
    message: string;
    confirmText?: string
}>(), ({
    confirmText: 'Confirmar'
}));

const emit = defineEmits(['close']);

</script>

<template>

    {{ message }}

    <div class="buttons">
        <GButton text="Cancelar" :block="true" @click="emit('close', false);"></GButton>
        <GButton type="primary" :text="confirmText" :block="true" @click="emit('close', true);"></GButton>
    </div>

</template>

<style lang="scss" scoped>
.buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-top: 24px;
}
</style>